var _rect, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDiscord = function SvgDiscord(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 123,
    viewBox: "0 0 123 123",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 123,
    height: 123,
    rx: 61.5,
    fill: "#5865F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.1633 45.0197C76.7018 43.4002 73.0007 42.2232 69.1313 41.553C68.6561 42.4121 68.1009 43.5677 67.7181 44.487C63.6048 43.8684 59.5293 43.8684 55.4917 44.487C55.109 43.5677 54.5412 42.4121 54.0617 41.553C50.1881 42.2232 46.4828 43.4045 43.0213 45.0283C36.0396 55.5786 34.147 65.8668 35.0933 76.009C39.7239 79.467 44.2116 81.5677 48.6235 82.9423C49.7128 81.4431 50.6844 79.8494 51.5213 78.1698C49.9273 77.5641 48.4006 76.8166 46.958 75.9489C47.3407 75.6654 47.7151 75.3689 48.0768 75.0639C56.8754 79.1793 66.4353 79.1793 75.1289 75.0639C75.4948 75.3689 75.869 75.6654 76.2476 75.9489C74.8008 76.8209 73.2699 77.5683 71.6759 78.1741C72.5128 79.8494 73.4802 81.4474 74.5737 82.9466C78.9898 81.572 83.4817 79.4714 88.1123 76.009C89.2227 64.2516 86.2155 54.0579 80.1633 45.0197ZM52.72 69.7716C50.0788 69.7716 47.9127 67.3059 47.9127 64.3032C47.9127 61.3005 50.0325 58.8304 52.72 58.8304C55.4076 58.8304 57.5736 61.2961 57.5273 64.3032C57.5315 67.3059 55.4076 69.7716 52.72 69.7716ZM70.4856 69.7716C67.8443 69.7716 65.6783 67.3059 65.6783 64.3032C65.6783 61.3005 67.798 58.8304 70.4856 58.8304C73.1731 58.8304 75.3392 61.2961 75.2929 64.3032C75.2929 67.3059 73.1731 69.7716 70.4856 69.7716Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDiscord, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/discord.e87440f7.svg";
export { ForwardRef as ReactComponent };